import PropTypes from 'prop-types';
import { DB_PREFIX, DB_PREFIX_INFO, DB_PREFIX_REGISTER } from './constants';

export default PropTypes.shape({
  [DB_PREFIX_REGISTER]: PropTypes.shape({
    registered: PropTypes.bool,
  }),
  [DB_PREFIX_INFO]: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    dateOfBirth: PropTypes.string,
    nationaly: PropTypes.string,
  }),
  [DB_PREFIX]: PropTypes.shape({
    id: PropTypes.string,
    fileURL: PropTypes.string,
    permissionToCheckDBS: PropTypes.bool,
  }),
});
